import { useNamespaceSelector } from '@omaze/redux';

import { selectFlags } from '../FeatureFlagModule/selectors/selectFlags/selectFlags';
import { IFeatureFlagMap } from '../interfaces/IFeatureFlagMap';

export function useFeatureFlags (): IFeatureFlagMap {
    return useNamespaceSelector(selectFlags);
}
